import type { ReactNode } from 'react'
import { EmptyState } from './BarListWidget'

export interface ListWidgetRow {
  id: string
  name: string
  avatar_url?: string | null
  subtitle?: ReactNode
  trailing?: ReactNode
}

/** Row-list for people widgets (birthdays, new joiners, anniversaries, my
 * team): avatar/initial, name, optional subtitle, optional trailing badge.
 * Shows the "No Record Found!" empty state when there's nothing to list. */
export default function ListWidget({ rows, emptyLabel }: { rows: ListWidgetRow[]; emptyLabel?: string }) {
  if (!rows || rows.length === 0) {
    return <EmptyState label={emptyLabel} />
  }
  return (
    <ul className="divide-y divide-gray-100">
      {rows.map((row) => (
        <li key={row.id} className="flex items-center gap-3 py-2.5 first:pt-0 last:pb-0">
          {row.avatar_url ? (
            <img src={row.avatar_url} alt="" className="h-8 w-8 rounded-full object-cover shrink-0" />
          ) : (
            <span className="h-8 w-8 rounded-full bg-brand/10 text-brand text-xs font-semibold flex items-center justify-center shrink-0">
              {row.name.charAt(0).toUpperCase()}
            </span>
          )}
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-gray-800 truncate">{row.name}</p>
            {row.subtitle && <p className="text-xs text-gray-400 truncate">{row.subtitle}</p>}
          </div>
          {row.trailing && <div className="shrink-0">{row.trailing}</div>}
        </li>
      ))}
    </ul>
  )
}
